import React, {useEffect, useState} from "react";
import { motion, AnimatePresence } from "framer-motion";
import {Ajax} from "../Service/ajax";
import {formatNumber} from "../config/AppConfig";
import "../assets/PricingCard.css";
import {useNavigate, useParams} from "react-router-dom";
import Swal from "sweetalert2";
import {plans_pm, security} from "../env/Environment";

const PricingCard = ({subscriptions}) => {
    const [activeIndex, setActiveIndex] = useState(0);
    const { pageUrl } = useParams();

    const [tiers, setTiers] = useState([
        { id:plans_pm.basic , price: 125, volume: "10 000 $ - 20 000$", additional: "4,2 % pour le volume de facturation supplémentaire", currency: "USD", name:"Basics" },
        { id:plans_pm.standard ,price: 1750, volume: "De 20 000 à 30 000 $", additional: "4,2 % pour le volume de facturation supplémentaire", currency: "USD",name:"Standard" },
        { id:plans_pm.pro ,price: 2250, volume: "De 30 000 à 50 000 $", additional: "4,2 % pour le volume de facturation supplémentaire", currency: "USD", name:"Pro" },
        { id:plans_pm.entreprise ,price: 2750, volume: "Plus de 50 000 $", additional: "Contactez-Nous.", currency: "USD", name:"Entreprise" },
    ]);

    const session = sessionStorage.getItem("session");

    const navigate = useNavigate();
    const urlSearchParams = new URLSearchParams(window.location.search);


    const fetchData = async (subscription)=>{
        try {
            const {data} = await Ajax.postRequest("/api/v1/sub/subscription/"+subscription.id+"/subscribe", []);
            if(data.error){
                const url = window.location.pathname + window.location.search;
                navigate("/payment-check", { state: { errors: url } });
            }else{
                const {object} = data;
                navigate("/payment-check", { state: { success: JSON.stringify(object) } });
            }
        }catch (error){
            const url = window.location.pathname + window.location.search;
            navigate("/payment-check", { state: { errors: url } });
        }
    }

    // const handleAccept = (subscription) => {
    //     if(limit >= 10){
    //         Swal.fire({
    //             title: 'Oops!',
    //             text: "Le nombre limite d'abonnement est deja atteint",
    //             icon: 'info',
    //             confirmButtonText: 'OK',
    //             timer: 10000
    //         });
    //     }else{
    //         handleNavigation(subscription);
    //     }
    // };

    const handleNavigation = (subscription) => {
        if(session) {
            if(subscription.price > 0){
                subscription["cmp"]=security.ntk_sub_cmp;
                navigate("/payment", { state: { someData: JSON.stringify(subscription) } });
            }else{
                fetchData();
            }
        } else {
            let location=window.location.origin+"/";
            if(location === window.location.href){
                navigate("/login/?target=subs")
            }else{
                navigate(`/login?target=own-page&target_id=${pageUrl}`);
            }
        }
    };


    async function loadConversion(amount, target, origin) {
        try {
            const { data } = await Ajax.getRequest(`/exposed/v1/loc/conversion-rates/convert`, {
                params: {
                    origin: origin,
                    target: target,
                    amount: amount
                }
            });

            return data?.converted_amount ? parseFloat(data.converted_amount.toFixed(2)) : null;
        } catch (e) {
            console.error(e);
            return null;
        }
    }

    useEffect(() => {
        const convertPricesAndUpdateTiers = async () => {
            // Créer un tableau avec les ids des plans dans plans_pm
            const plansIds = Object.values(plans_pm);

            // Filtrer les abonnements dont l'ID est dans plansIds
            const filteredSubscriptions = subscriptions.filter(subscription =>
                plansIds.includes(subscription.id)
            );

            // Mettre à jour les éléments de tiers en fonction des abonnements filtrés
            const updatedTiers = await Promise.all(
                tiers.map(async (tier) => {
                    // Trouver l'abonnement correspondant au plan
                    const matchingSubscription = filteredSubscriptions.find(subscription => subscription.id === tier.id);

                    let updatedTier = tier;

                    // Si un abonnement est trouvé, mettre à jour les informations
                    if (matchingSubscription) {
                        updatedTier = {
                            ...tier,
                            price: matchingSubscription.price,
                            currency: matchingSubscription.currency,
                            name: matchingSubscription.title
                        };
                    }

                    // Effectuer la conversion des prix
                    const convertedAmount = await loadConversion(updatedTier.price, updatedTier.currency === "USD" ? "CDF" : "USD", updatedTier.currency);

                    // Retourner le tier mis à jour avec le prix converti
                    return {
                        ...updatedTier,
                        balancedPrice: convertedAmount !== null ? convertedAmount : updatedTier.price // Si la conversion échoue, conservez le prix d'origine
                    };
                })
            );

            // Mettre à jour l'état tiers avec les valeurs mises à jour
            setTiers(updatedTiers);
        };

        convertPricesAndUpdateTiers();
    }, [subscriptions]); // Re-exécuter lorsque subscriptions change



    const handleSubscribe = () => {
        if(session) {
            Swal.fire({
                title: 'Message important',
                text: "Vous êtes sur le point de vous abonner à ce service. Soyez rassurés que toute  information personnelle qui vous sera demandée sera gardée privée et traitée conformément à notre politique de confidentialité !",
                icon: 'info',
                showCancelButton: true,
                confirmButtonColor:'#debf66',
                focusConfirm:true,
                confirmButtonText: 'Continuer',
                cancelButtonText:'Annuler'
            }).then((result) => {
                if (result.isConfirmed) {
                    let selected = subscriptions.find(subscription => subscription.id === tiers[activeIndex].id);
                    handleNavigation(selected);
                }
            })
        }else{
            let location=window.location.origin+"/";
            if(location === window.location.href){
                navigate("/login?target=subs")
            }else{
                navigate(`/login?target=own-page&target_id=${pageUrl}`);
            }
        }
    }

    const handleSliderChange = (event) => {
        setActiveIndex(Number(event.target.value));
    };

    return (
        <motion.section
            className="bg-white shadow-lg rounded-3 mx-auto text-center"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
        >
            <div className="p-4 h-px-150">
                <h1 className="h3 font-weight-bold text-dark mb-3">Paiement Mensuel</h1>
                <p className="text-muted mb-6">Abonnement annuel, payé mensuellement. Choisissez un volume adapté à votre business.</p>
            </div>

            <div className="p-4 h-px-250" style={{ backgroundColor: "#f6f6f6" }}>
                {/* Pricing Info */}
                <AnimatePresence mode="wait">
                    <motion.div
                        key={activeIndex}
                        initial={{ opacity: 0, scale: 0.9 }}
                        animate={{ opacity: 1, scale: 1 }}
                        exit={{ opacity: 0, scale: 0.9 }}
                        transition={{ duration: 0.3 }}
                        className="mb-6"
                    >
                        {tiers[activeIndex].balancedPrice && (
                            <motion.span
                                className="badge bg-warning text-dark px-3 py-1 rounded text-sm font-weight-semibold"
                                initial={{ scale: 0.8 }}
                                animate={{ scale: 1 }}
                            >
                                {tiers[activeIndex].currency === "USD" ? "CDF " : "$ "}{formatNumber(tiers[activeIndex].balancedPrice)}
                            </motion.span>
                        )}
                        <h2 className="h1 font-weight-bold text-dark mt-3">
                            {tiers[activeIndex].id === plans_pm.entreprise
                                ? "Contactez-Nous"
                                : `${tiers[activeIndex].currency === "USD" ? "$ " : "CDF "}${tiers[activeIndex].price}`}
                        </h2>

                        <p className="text-muted">{tiers[activeIndex].volume}</p>
                        {tiers[activeIndex].additional && <p className="text-muted small">{tiers[activeIndex].additional}</p>}
                    </motion.div>
                </AnimatePresence>

                {/* Slider with Progress Bar */}
                <div className="w-100 d-flex flex-column align-items-center">
                    <div className="position-relative w-100">
                        <input
                            type="range"
                            min="0"
                            max={tiers.length - 1}
                            value={activeIndex}
                            onChange={handleSliderChange}
                            className="custom-slider w-100"
                            style={{
                                background: `linear-gradient(to right, #eccd7e ${(activeIndex / (tiers.length - 1)) * 100}%, #ddd ${(activeIndex / (tiers.length - 1)) * 100}%)`,
                            }}
                        />
                        {/* Repères (Dots) */}
                        <div className="slider-dots">
                            {tiers.map((_, index) => (
                                <span
                                    key={index}
                                    className={`dot ${index === activeIndex ? "active-dot" : ""}`}
                                    style={{ left: `${(index / (tiers.length - 1)) * 100}%` }}
                                />
                            ))}
                        </div>
                    </div>
                </div>

                <AnimatePresence mode="wait">
                    <motion.div
                        key={activeIndex}
                        initial={{ opacity: 0, scale: 0.9 }}
                        animate={{ opacity: 1, scale: 1 }}
                        exit={{ opacity: 0, scale: 0.9 }}
                        transition={{ duration: 0.3 }}
                        className="mb-6"
                    >
                        <h2 className="h1 font-weight-bold text-dark mt-3">
                            {tiers[activeIndex].name}
                        </h2>
                    </motion.div>
                </AnimatePresence>

            </div>
            <div className="p-4" style={{ backgroundColor: "#f6f6f6" }}>
                {/* Contact Button */}
                <motion.button
                    className="mt-4 btn btn-lg btn-netikash text-white rounded-lg shadow-sm hover-shadow"
                    whileHover={{ scale: 1.05 }}
                    onClick={() => window.open("https://akiba.netikash.com/contact", "_blank")}
                >
                    {"Contactez-Nous"}
                </motion.button>
            </div>
        </motion.section>
    );
};

export default PricingCard;
